/* AOOCCI Gift Progress v2.7 — Kalles 4/5 compatible, shared across 9 storefronts */
(function () {
  'use strict';

  var GLOBAL_KEY = 'AoocciGiftProgress';

  if (window[GLOBAL_KEY] && window[GLOBAL_KEY].initialized) {
    window[GLOBAL_KEY].refresh();
    return;
  }

  var SELECTOR = '[data-aoocci-gift-progress]';
  var MINOR_UNIT = 100;
  var REQUIRED_PAID_QUANTITY = 2;
  var DEFAULT_THRESHOLDS = {
    EUR: 18000,
    PHP: 1300000,
    USD: 20000
  };
  var DEFAULT_QUALIFICATION_THRESHOLDS = {
    EUR: 23000,
    PHP: 1300000,
    USD: 20000
  };
  var DEFAULT_QUALIFICATION_BASIS = {
    EUR: 'original',
    PHP: 'discounted',
    USD: 'discounted'
  };
  var DOMAIN_RULES = [
    {
      pattern: /(^|\.)aoocci\.de$/i,
      language: 'de', currency: 'EUR', threshold: 18000,
      giftVariantIds: ['52286762549615'],
      glassEligibleProductIds: ['14723164864879', '14723251372399', '14723326280047', '14992845111663']
    },
    {
      pattern: /(^|\.)aoocci\.es$/i,
      language: 'es', currency: 'EUR', threshold: 18000,
      giftVariantIds: ['54202422558888'],
      glassEligibleProductIds: ['9116885680296', '9125195120808', '9120924401832', '9470397874344']
    },
    {
      pattern: /(^|\.)aoocci\.gr$/i,
      language: 'el', currency: 'EUR', threshold: 18000,
      giftVariantIds: ['52313822757182'],
      glassEligibleProductIds: ['11974829670718', '11974843826494', '11975887192382', '12458303488318']
    },
    {
      pattern: /(^|\.)aoocci\.fr$/i,
      language: 'fr', currency: 'EUR', threshold: 18000,
      giftVariantIds: ['62550126756209'],
      glassEligibleProductIds: ['15284002586993', '15283513557361', '15284544831857', '15614056333681']
    },
    {
      pattern: /(^|\.)aoocci\.nl$/i,
      language: 'nl', currency: 'EUR', threshold: 18000,
      giftVariantIds: ['42079549423687'],
      glassEligibleProductIds: ['7294641668167', '7300213080135', '7300210425927', '7574254616647']
    },
    {
      pattern: /(^|\.)aoocci\.it$/i,
      language: 'it', currency: 'EUR', threshold: 18000,
      giftVariantIds: ['43606070919228'],
      glassEligibleProductIds: ['8668947251260', '8669911941180', '8671262539836', '8938849435708']
    },
    {
      pattern: /(^|\.)aoocci\.pl$/i,
      language: 'pl', currency: 'EUR', threshold: 18000,
      giftVariantIds: ['50587197473046'],
      glassEligibleProductIds: ['10224292921622', '10226531434774', '10226506989846', '10597554979094']
    },
    {
      pattern: /(^|\.)aoocci\.ph$/i,
      language: 'ph', currency: 'PHP', threshold: 1300000,
      giftVariantIds: ['53490093425012'],
      glassEligibleProductIds: ['14787171844468', '14788457595252', '14788529619316', '15105074135412']
    },
    {
      pattern: /(^|\.)aoocci\.com\.in$/i,
      language: 'hi', currency: 'USD', threshold: 20000,
      giftVariantIds: ['55022623523201'],
      glassEligibleProductIds: ['15244650545537', '15244650611073', '15244650578305', '15427965419905']
    }
  ];

  var LOCALE_FOR_FORMATTING = {
    de: 'de-DE',
    es: 'es-ES',
    el: 'el-GR',
    fr: 'fr-FR',
    nl: 'nl-NL',
    it: 'it-IT',
    pl: 'pl-PL',
    ph: 'en-PH',
    hi: 'hi-IN',
    en: 'en-US'
  };

  var COPY = {
    de: {
      eyebrow: "DIWALI-GESCHENKE",
      glassAvailable: 'Beim Kauf dieses Produkts erhältst du eine passende Schutzfolie aus gehärtetem Glas gratis.',
      glassUnlocked: 'Gratis-Schutzfolie aus gehärtetem Glas freigeschaltet!',
      addOne: 'Füge noch 1 kostenpflichtigen Artikel hinzu und sichere dir einen Gratis-Schlüsselanhänger.',
      addMany: 'Füge noch {count} kostenpflichtige Artikel hinzu und sichere dir einen Gratis-Schlüsselanhänger.',
      addOneForK3: 'Füge noch 1 kostenpflichtigen Artikel hinzu, um dein K3-Geschenk freizuschalten.',
      addManyForK3: 'Füge noch {count} kostenpflichtige Artikel hinzu, um dein K3-Geschenk freizuschalten.',
      spendMore: 'Gratis-Schlüsselanhänger freigeschaltet! Nur noch {amount} bis zum Upgrade auf die K3-Taschenlampe.',
      spendMoreOriginal: 'Gratis-Schlüsselanhänger freigeschaltet! Noch {amount} Warenwert vor Rabatt bis zum Upgrade auf die K3-Taschenlampe.',
      k3Unlocked: 'Upgrade auf die K3-Taschenlampe freigeschaltet!',
      itemStep: '2 kostenpflichtige Artikel',
      k3Step: 'Sobald der Zahlbetrag der Bestellung {threshold} erreicht, wird das Geschenk auf die K3-Taschenlampe aufgewertet.',
      campaignButton: "Diwali-Geschenke ansehen",
      campaignUrl: '/pages/campaign',
      discountButton: 'TREAT kopieren und sofort 18 % Rabatt sichern',
      discountCode: 'TREAT',
      discountCopied: 'TREAT kopiert!',
      discountCopyFailed: 'Kopieren fehlgeschlagen. Bitte TREAT manuell kopieren.',
      limited: '',
      progressLabel: "Fortschritt für Diwali-Geschenke"
    },
    es: {
      eyebrow: "REGALOS DE DIWALI",
      glassAvailable: 'Compra este producto y recibe gratis un protector de pantalla de vidrio templado compatible.',
      glassUnlocked: '¡Protector de pantalla de vidrio templado gratis desbloqueado!',
      addOne: 'Añade 1 artículo de pago más y consigue un llavero de regalo.',
      addMany: 'Añade {count} artículos de pago más y consigue un llavero de regalo.',
      addOneForK3: 'Añade 1 artículo de pago más para desbloquear tu regalo K3.',
      addManyForK3: 'Añade {count} artículos de pago más para desbloquear tu regalo K3.',
      spendMore: '¡Llavero de regalo desbloqueado! Compra por {amount} más para conseguir el K3.',
      spendMoreOriginal: '¡Llavero de regalo desbloqueado! Añade {amount} más de valor antes del descuento para subir al regalo linterna K3.',
      k3Unlocked: '¡Mejora a la linterna K3 desbloqueada!',
      itemStep: '2 artículos de pago',
      k3Step: 'Pago superior a {threshold}: mejora a linterna K3',
      campaignButton: "Ver regalos de Diwali",
      campaignUrl: '/pages/campaign',
      discountButton: 'Copia TREAT y usa ahora el 18 % de descuento',
      discountCode: 'TREAT',
      discountCopied: '¡TREAT copiado!',
      discountCopyFailed: 'No se pudo copiar. Copia TREAT manualmente.',
      limited: '',
      progressLabel: "Progreso de regalos de Diwali"
    },
    el: {
      eyebrow: "ΔΩΡΑ DIWALI",
      glassAvailable: 'Με την αγορά αυτού του προϊόντος λαμβάνεις δωρεάν συμβατό προστατευτικό οθόνης από σκληρυμένο γυαλί.',
      glassUnlocked: 'Ξεκλείδωσες δωρεάν προστατευτικό οθόνης από σκληρυμένο γυαλί!',
      addOne: 'Πρόσθεσε ακόμη 1 προϊόν επί πληρωμή και κέρδισε ένα μπρελόκ δώρο.',
      addMany: 'Πρόσθεσε ακόμη {count} προϊόντα επί πληρωμή και κέρδισε ένα μπρελόκ δώρο.',
      addOneForK3: 'Πρόσθεσε ακόμη 1 προϊόν επί πληρωμή για να ξεκλειδώσεις το δώρο K3.',
      addManyForK3: 'Πρόσθεσε ακόμη {count} προϊόντα επί πληρωμή για να ξεκλειδώσεις το δώρο K3.',
      spendMore: 'Ξεκλείδωσες το μπρελόκ δώρο! Αγόρασε ακόμη {amount} για να κερδίσεις το K3.',
      spendMoreOriginal: 'Ξεκλείδωσες το μπρελόκ δώρο! Πρόσθεσε ακόμη {amount} αξίας πριν από την έκπτωση για αναβάθμιση στον φακό K3.',
      k3Unlocked: 'Ξεκλείδωσες την αναβάθμιση στον φακό K3!',
      itemStep: '2 προϊόντα επί πληρωμή',
      k3Step: 'Πληρωμή άνω των {threshold}: αναβάθμιση σε φακό K3',
      campaignButton: "Δείτε τα δώρα Diwali",
      campaignUrl: '/pages/campaign',
      discountButton: 'Αντιγράψτε το TREAT και χρησιμοποιήστε τώρα την έκπτωση 18%',
      discountCode: 'TREAT',
      discountCopied: 'Το TREAT αντιγράφηκε!',
      discountCopyFailed: 'Η αντιγραφή απέτυχε. Αντιγράψτε το TREAT χειροκίνητα.',
      limited: '',
      progressLabel: "Πρόοδος δώρων Diwali"
    },
    fr: {
      eyebrow: "CADEAUX DE DIWALI",
      glassAvailable: 'Achetez ce produit et recevez gratuitement un verre trempé compatible.',
      glassUnlocked: 'Verre trempé compatible offert débloqué !',
      addOne: 'Ajoutez encore 1 article payant et recevez un porte-clés offert.',
      addMany: 'Ajoutez encore {count} articles payants et recevez un porte-clés offert.',
      addOneForK3: 'Ajoutez encore 1 article payant pour débloquer votre cadeau K3.',
      addManyForK3: 'Ajoutez encore {count} articles payants pour débloquer votre cadeau K3.',
      spendMore: 'Porte-clés offert débloqué ! Plus que {amount} pour recevoir le K3.',
      spendMoreOriginal: 'Porte-clés offert débloqué ! Ajoutez encore {amount} de valeur avant remise pour passer à la lampe torche K3.',
      k3Unlocked: 'Passage à la lampe torche K3 débloqué !',
      itemStep: '2 articles payants',
      k3Step: 'Montant payé supérieur à {threshold} : passage à la lampe torche K3',
      campaignButton: "Voir les cadeaux de Diwali",
      campaignUrl: '/pages/campaign',
      discountButton: 'Copiez TREAT et profitez immédiatement de 18 % de réduction',
      discountCode: 'TREAT',
      discountCopied: 'TREAT copié !',
      discountCopyFailed: 'Échec de la copie. Copiez TREAT manuellement.',
      limited: '',
      progressLabel: "Progression des cadeaux de Diwali"
    },
    nl: {
      eyebrow: "DIWALICADEAUS",
      glassAvailable: 'Koop dit product en ontvang gratis een passende screenprotector van gehard glas.',
      glassUnlocked: 'Gratis passende screenprotector van gehard glas vrijgespeeld!',
      addOne: 'Voeg nog 1 betaald artikel toe en ontvang een gratis sleutelhanger.',
      addMany: 'Voeg nog {count} betaalde artikelen toe en ontvang een gratis sleutelhanger.',
      addOneForK3: 'Voeg nog 1 betaald artikel toe om je K3-cadeau vrij te spelen.',
      addManyForK3: 'Voeg nog {count} betaalde artikelen toe om je K3-cadeau vrij te spelen.',
      spendMore: 'Gratis sleutelhanger vrijgespeeld! Besteed nog {amount} om de K3 te ontvangen.',
      spendMoreOriginal: 'Gratis sleutelhanger vrijgespeeld! Voeg nog {amount} aan waarde vóór korting toe voor een upgrade naar de K3-zaklamp.',
      k3Unlocked: 'Upgrade naar de K3-zaklamp vrijgespeeld!',
      itemStep: '2 betaalde artikelen',
      k3Step: 'Betaald bedrag boven {threshold}: upgrade naar K3-zaklamp',
      campaignButton: "Bekijk de Diwalicadeaus",
      campaignUrl: '/pages/campaign',
      discountButton: 'Kopieer TREAT en gebruik direct 18% korting',
      discountCode: 'TREAT',
      discountCopied: 'TREAT gekopieerd!',
      discountCopyFailed: 'Kopiëren mislukt. Kopieer TREAT handmatig.',
      limited: '',
      progressLabel: "Voortgang Diwali-cadeaus"
    },
    it: {
      eyebrow: "REGALI DI DIWALI",
      glassAvailable: 'Acquista questo prodotto e ricevi gratis una pellicola protettiva compatibile in vetro temperato.',
      glassUnlocked: 'Pellicola protettiva compatibile in vetro temperato sbloccata!',
      addOne: 'Aggiungi ancora 1 articolo a pagamento e ricevi un portachiavi in regalo.',
      addMany: 'Aggiungi ancora {count} articoli a pagamento e ricevi un portachiavi in regalo.',
      addOneForK3: 'Aggiungi ancora 1 articolo a pagamento per sbloccare il regalo K3.',
      addManyForK3: 'Aggiungi ancora {count} articoli a pagamento per sbloccare il regalo K3.',
      spendMore: 'Portachiavi in regalo sbloccato! Ti mancano {amount} per ricevere il K3.',
      spendMoreOriginal: 'Portachiavi in regalo sbloccato! Aggiungi ancora {amount} di valore prima dello sconto per passare alla torcia K3.',
      k3Unlocked: 'Upgrade alla torcia K3 sbloccato!',
      itemStep: '2 articoli a pagamento',
      k3Step: 'Importo pagato oltre {threshold}: upgrade alla torcia K3',
      campaignButton: "Scopri i regali di Diwali",
      campaignUrl: '/pages/campaign',
      discountButton: 'Copia TREAT e usa subito il 18% di sconto',
      discountCode: 'TREAT',
      discountCopied: 'TREAT copiato!',
      discountCopyFailed: 'Copia non riuscita. Copia TREAT manualmente.',
      limited: '',
      progressLabel: "Avanzamento regali di Diwali"
    },
    pl: {
      eyebrow: "PREZENTY NA DIWALI",
      glassAvailable: 'Kup ten produkt i odbierz gratis pasujące szkło hartowane na ekran.',
      glassUnlocked: 'Darmowe pasujące szkło hartowane na ekran odblokowane!',
      addOne: 'Dodaj jeszcze 1 płatny produkt i odbierz brelok gratis.',
      addMany: 'Dodaj jeszcze {count} płatne produkty i odbierz brelok gratis.',
      addOneForK3: 'Dodaj jeszcze 1 płatny produkt, aby odblokować prezent K3.',
      addManyForK3: 'Dodaj jeszcze {count} płatne produkty, aby odblokować prezent K3.',
      spendMore: 'Brelok gratis odblokowany! Wydaj jeszcze {amount}, aby otrzymać K3.',
      spendMoreOriginal: 'Brelok gratis odblokowany! Dodaj jeszcze {amount} wartości przed rabatem, aby zmienić prezent na latarkę K3.',
      k3Unlocked: 'Zmiana prezentu na latarkę K3 odblokowana!',
      itemStep: '2 płatne produkty',
      k3Step: 'Płatność powyżej {threshold}: prezent zmienia się na latarkę K3',
      campaignButton: "Zobacz prezenty na Diwali",
      campaignUrl: '/pages/campaign',
      discountButton: 'Skopiuj TREAT i od razu skorzystaj z 18% rabatu',
      discountCode: 'TREAT',
      discountCopied: 'Skopiowano TREAT!',
      discountCopyFailed: 'Nie udało się skopiować. Skopiuj TREAT ręcznie.',
      limited: '',
      progressLabel: "Postęp prezentów na Diwali"
    },
    ph: {
      eyebrow: "DIWALI FREE GIFTS",
      glassAvailable: 'Bilhin ang product na ito para makakuha ng FREE compatible tempered-glass screen protector.',
      glassUnlocked: 'Unlocked na ang FREE compatible tempered-glass screen protector!',
      addOne: 'Magdagdag pa ng 1 paid item para makakuha ng FREE keychain.',
      addMany: 'Magdagdag pa ng {count} paid items para makakuha ng FREE keychain.',
      addOneForK3: 'Magdagdag pa ng 1 paid item para ma-unlock ang FREE K3.',
      addManyForK3: 'Magdagdag pa ng {count} paid items para ma-unlock ang FREE K3.',
      spendMore: 'Unlocked na ang FREE keychain! {amount} na lang para makuha ang K3.',
      spendMoreOriginal: 'Unlocked na ang FREE keychain! Magdagdag pa ng {amount} na value before discount para mag-upgrade sa K3 flashlight.',
      k3Unlocked: 'Unlocked na ang upgrade sa FREE K3 flashlight!',
      itemStep: '2 paid items',
      k3Step: 'Paid amount over {threshold}: upgrade to K3 flashlight',
      campaignButton: "Tingnan ang Diwali Gifts",
      campaignUrl: '/pages/campaign',
      discountButton: 'I-copy ang TREAT at gamitin agad ang 18% off',
      discountCode: 'TREAT',
      discountCopied: 'Na-copy na ang TREAT!',
      discountCopyFailed: 'Hindi na-copy. Paki-copy nang manual ang TREAT.',
      limited: '',
      progressLabel: "Diwali gift progress"
    },
    hi: {
      eyebrow: "दिवाली के मुफ़्त उपहार",
      glassAvailable: 'यह product खरीदें और FREE compatible tempered-glass screen protector पाएं।',
      glassUnlocked: 'FREE compatible tempered-glass screen protector unlock हो गया!',
      addOne: '1 और paid item जोड़ें और FREE keychain पाएं।',
      addMany: '{count} और paid items जोड़ें और FREE keychain पाएं।',
      addOneForK3: 'FREE K3 unlock करने के लिए 1 और paid item जोड़ें।',
      addManyForK3: 'FREE K3 unlock करने के लिए {count} और paid items जोड़ें।',
      spendMore: 'FREE keychain unlock हो गया! K3 पाने के लिए केवल {amount} और खरीदें।',
      spendMoreOriginal: 'FREE keychain unlock हो गया! K3 flashlight upgrade के लिए discount से पहले {amount} की value और जोड़ें।',
      k3Unlocked: 'FREE K3 flashlight upgrade unlock हो गया!',
      itemStep: '2 paid items',
      k3Step: '{threshold} से अधिक paid amount: K3 flashlight upgrade',
      campaignButton: "दिवाली के उपहार देखें",
      campaignUrl: '/pages/campaign',
      discountButton: 'LIGHT कॉपी करें और तुरंत 20% छूट पाएं',
      discountCode: 'LIGHT',
      discountCopied: 'LIGHT कॉपी हो गया!',
      discountCopyFailed: 'कॉपी नहीं हो सका। कृपया LIGHT को मैन्युअल रूप से कॉपी करें।',
      limited: '',
      progressLabel: "दिवाली उपहारों की प्रगति"
    },
    en: {
      campaignButton: "View Diwali gifts",
      campaignUrl: "/en/pages/campaign",
      discountButton: "Copy LIGHT and get 20% off instantly",
      discountCode: "LIGHT",
      discountCopied: "LIGHT copied!",
      discountCopyFailed: "Could not copy. Please copy LIGHT manually.",
      eyebrow: "DIWALI FREE GIFTS",
      glassAvailable: 'Buy this product to receive a FREE matching tempered-glass screen protector.',
      glassUnlocked: 'FREE matching tempered-glass screen protector unlocked!',
      addOne: 'Add 1 more paid item to unlock a FREE keychain.',
      addMany: 'Add {count} more paid items to unlock a FREE keychain.',
      addOneForK3: 'Add 1 more paid item to unlock your FREE K3.',
      addManyForK3: 'Add {count} more paid items to unlock your FREE K3.',
      spendMore: 'FREE keychain unlocked! Spend {amount} more to unlock the K3.',
      spendMoreOriginal: 'FREE keychain unlocked! Add {amount} more in pre-discount value to upgrade to the K3 flashlight.',
      k3Unlocked: 'Upgrade to the FREE K3 flashlight unlocked!',
      itemStep: '2 paid items',
      k3Step: 'Paid amount over {threshold}: upgrade to K3 flashlight',
      limited: '',
      progressLabel: "Diwali gift progress"
    }
  };

  var refreshTimer = null;
  var requestSequence = 0;
  var discountRequestSequence = 0;
  var lastCart = null;
  var warnedCurrencies = {};

  function normaliseHost(host) {
    return String(host || window.location.hostname || '')
      .toLowerCase()
      .replace(/^www\./, '')
      .split(':')[0];
  }

  function getDomainRule(host) {
    var normalisedHost = normaliseHost(host);
    for (var i = 0; i < DOMAIN_RULES.length; i += 1) {
      if (DOMAIN_RULES[i].pattern.test(normalisedHost)) return DOMAIN_RULES[i];
    }
    return null;
  }

  function getLanguage(widget) {
    var requestedLocale = String(widget.dataset.locale || document.documentElement.lang || '').toLowerCase().split('-')[0];
    if (requestedLocale === 'en') return 'en';
    var rule = getDomainRule(widget.dataset.shopHost);
    if (rule) return rule.language;

    var country = String(widget.dataset.country || '').toUpperCase();
    var countryMap = {
      DE: 'de', ES: 'es', GR: 'el', FR: 'fr', NL: 'nl',
      IT: 'it', PL: 'pl', PH: 'ph', IN: 'hi'
    };
    if (countryMap[country]) return countryMap[country];

    var locale = String(widget.dataset.locale || document.documentElement.lang || 'en')
      .toLowerCase()
      .split('-')[0];
    return COPY[locale] ? locale : 'en';
  }

  function parsePositiveInteger(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? Math.round(number) : null;
  }

  function parseIdList(value) {
    return String(value || '')
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(Boolean);
  }

  function getWidgetConfig(widget, cart) {
    var rule = getDomainRule(widget.dataset.shopHost);
    var cartCurrency = String(cart.currency || widget.dataset.currency || '').toUpperCase();
    var overrideCurrency = String(widget.dataset.thresholdCurrency || '').toUpperCase();
    var overrideThreshold = parsePositiveInteger(widget.dataset.thresholdMinor);
    var overrideQualificationThreshold = parsePositiveInteger(widget.dataset.qualificationThresholdMinor);
    var overrideQualificationBasis = String(widget.dataset.qualificationBasis || '').toLowerCase();
    var currency = overrideCurrency || cartCurrency || (rule && rule.currency) || '';
    var threshold = overrideThreshold;
    var qualificationThreshold;
    var qualificationBasis;

    if (!threshold && rule && currency === rule.currency) threshold = rule.threshold;
    if (!threshold) threshold = DEFAULT_THRESHOLDS[currency] || null;

    qualificationThreshold = overrideQualificationThreshold || DEFAULT_QUALIFICATION_THRESHOLDS[currency] || threshold;
    qualificationBasis = ['original', 'discounted'].indexOf(overrideQualificationBasis) !== -1
      ? overrideQualificationBasis
      : (DEFAULT_QUALIFICATION_BASIS[currency] || 'discounted');

    return {
      language: getLanguage(widget),
      currency: currency,
      cartCurrency: cartCurrency,
      threshold: threshold,
      qualificationThreshold: qualificationThreshold,
      qualificationBasis: qualificationBasis,
      giftVariantIds: new Set(
        (rule && rule.giftVariantIds ? rule.giftVariantIds : [])
          .concat(parseIdList(widget.dataset.giftVariantIds))
      ),
      glassEligibleProductIds: new Set(
        (rule && rule.glassEligibleProductIds ? rule.glassEligibleProductIds : [])
          .concat(parseIdList(widget.dataset.glassEligibleProductIds))
      ),
      currentProductId: String(widget.dataset.currentProductId || '').trim()
    };
  }

  function localizeIndiaButtonText(widget, value) {
    if (getLanguage(widget) !== 'en' || normaliseHost(widget.dataset.shopHost) !== 'aoocci.com.in') return value;
    var translations = {"दिवाली के उपहार देखें": "View Diwali gifts", "LIGHT कॉपी करें और तुरंत 20% छूट पाएं": "Copy LIGHT and get 20% off instantly", "LIGHT कॉपी हो गया!": "LIGHT copied!", "कॉपी नहीं हो सका। कृपया LIGHT को मैन्युअल रूप से कॉपी करें।": "Could not copy. Please copy LIGHT manually."};
    return Object.prototype.hasOwnProperty.call(translations, value) ? translations[value] : value;
  }

  function localizeIndiaCampaignUrl(widget, value) {
    if (getLanguage(widget) !== 'en' || normaliseHost(widget.dataset.shopHost) !== 'aoocci.com.in') return value;
    var target;
    try { target = new URL(value, 'https://aoocci.com.in'); } catch (error) { return value; }
    if (target.origin !== 'https://aoocci.com.in' || !/^\/(pages|collections|products|blogs)\//.test(target.pathname)) return value;
    return '/en' + target.pathname + target.search + target.hash;
  }

  function getButtonConfig(widget, copy) {
    var requestedAction = String(widget.dataset.discountAction || 'auto').toLowerCase();
    var discountAction = ['auto', 'copy', 'link', 'hidden'].indexOf(requestedAction) !== -1
      ? requestedAction
      : 'auto';
    var configuredDiscountCode = String(widget.dataset.discountCode || '').trim();
    var discountCode = configuredDiscountCode || copy.discountCode || '';
    var discountUrl = String(widget.dataset.discountUrl || '').trim() || copy.discountUrl || '';

    if (discountAction === 'auto') {
      if (copy.discountCode) discountAction = 'copy';
      else if (copy.discountUrl) discountAction = 'link';
      else if (configuredDiscountCode) discountAction = 'copy';
      else if (discountUrl) discountAction = 'link';
      else discountAction = 'hidden';
    }

    return {
      campaignVisible: String(widget.dataset.campaignVisible || '').toLowerCase() !== 'false',
      campaignButton: localizeIndiaButtonText(widget, String(widget.dataset.campaignButtonText || '').trim() || copy.campaignButton || ''),
      campaignUrl: localizeIndiaCampaignUrl(widget, String(widget.dataset.campaignUrl || '').trim() || copy.campaignUrl || ''),
      discountAction: discountAction,
      discountCode: discountCode,
      discountUrl: discountUrl,
      discountButton: localizeIndiaButtonText(widget, String(widget.dataset.discountButtonText || '').trim() || copy.discountButton || ''),
      discountCopied: localizeIndiaButtonText(widget, String(widget.dataset.discountSuccessText || '').trim() || copy.discountCopied || discountCode),
      discountCopyFailed: localizeIndiaButtonText(widget, String(widget.dataset.discountFailedText || '').trim() || copy.discountCopyFailed || ''),
      copyResetMs: Math.max(1000, Math.min(10000, parsePositiveInteger(widget.dataset.copyResetMs) || 2200))
    };
  }

  function isTruthyMarker(value) {
    if (value === true || value === 1) return true;
    return ['true', '1', 'yes', 'gift'].indexOf(String(value || '').toLowerCase()) !== -1;
  }

  function isGiftLine(item, giftVariantIds) {
    var properties = item && item.properties ? item.properties : {};
    var markedAsGift = isTruthyMarker(properties._aoocci_gift);
    var variantId = String((item && (item.variant_id || item.id)) || '');
    return markedAsGift || giftVariantIds.has(variantId);
  }

  function getPaidCartState(cart, giftVariantIds) {
    var state = (cart.items || []).reduce(function (result, item) {
      var finalLinePrice = Number(item.final_line_price);
      var quantity = Math.max(0, Number(item.quantity) || 0);
      var originalLinePrice = Number(item.original_line_price);
      if (!Number.isFinite(finalLinePrice)) finalLinePrice = Number(item.line_price) || 0;
      if (!Number.isFinite(originalLinePrice)) originalLinePrice = Number(item.original_price) * quantity;
      if (!Number.isFinite(originalLinePrice)) originalLinePrice = finalLinePrice;
      finalLinePrice = Math.max(0, finalLinePrice);
      originalLinePrice = Math.max(0, originalLinePrice);

      if (isGiftLine(item, giftVariantIds)) {
        result.giftSubtotal += finalLinePrice;
        return result;
      }

      result.quantity += quantity;
      result.subtotal += finalLinePrice;
      result.originalSubtotal += originalLinePrice;
      return result;
    }, { quantity: 0, subtotal: 0, originalSubtotal: 0, giftSubtotal: 0 });

    /*
      final_line_price covers line-level discounts. cart.total_price also
      reflects cart-level discount codes. Taking the lower paid-item amount
      prevents a cart-level code from incorrectly leaving the K3 unlocked.
    */
    var cartTotal = Number(cart.total_price);
    if (Number.isFinite(cartTotal)) {
      var discountedPaidTotal = Math.max(0, cartTotal - state.giftSubtotal);
      state.subtotal = Math.min(state.subtotal, discountedPaidTotal);
    }

    return state;
  }

  function formatMoney(minorAmount, currency, language) {
    var locale = LOCALE_FOR_FORMATTING[language] || LOCALE_FOR_FORMATTING.en;
    var amount = minorAmount / MINOR_UNIT;
    var hasFraction = Math.abs(minorAmount % MINOR_UNIT) > 0;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: hasFraction ? 2 : 0
      }).format(amount);
    } catch (error) {
      return currency + ' ' + amount.toFixed(hasFraction ? 2 : 0);
    }
  }

  function interpolate(template, values) {
    return String(template).replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function setText(widget, selector, text) {
    var element = widget.querySelector(selector);
    if (element) element.textContent = text;
  }

  function fallbackCopyText(text) {
    var activeElement = document.activeElement;
    var textarea = document.createElement('textarea');
    var copied = false;

    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.setAttribute('aria-hidden', 'true');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    textarea.remove();
    if (activeElement && typeof activeElement.focus === 'function') {
      try {
        activeElement.focus({ preventScroll: true });
      } catch (error) {
        activeElement.focus();
      }
    }
    return copied;
  }

  function copyTextToClipboard(text) {
    var normalisedText = String(text || '').trim();
    if (!normalisedText) return Promise.resolve(false);

    if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(normalisedText).then(function () {
        return true;
      }).catch(function () {
        return fallbackCopyText(normalisedText);
      });
    }

    return Promise.resolve(fallbackCopyText(normalisedText));
  }

  function renderWidget(widget, cart) {
    var config = getWidgetConfig(widget, cart);

    if (!config.threshold || !config.qualificationThreshold || !config.currency || (config.cartCurrency && config.currency !== config.cartCurrency)) {
      widget.hidden = true;
      var warningKey = config.cartCurrency + ':' + config.currency;
      if (!warnedCurrencies[warningKey]) {
        warnedCurrencies[warningKey] = true;
        console.warn('[AOOCCI Gift Progress] No valid threshold for the active cart currency.', {
          cartCurrency: config.cartCurrency,
          configuredCurrency: config.currency
        });
      }
      return;
    }

    var copy = COPY[config.language] || COPY.en;
    var buttons = getButtonConfig(widget, copy);
    var paidCart = getPaidCartState(cart, config.giftVariantIds);
    var glassUnlocked = (cart.items || []).some(function (item) {
      return Number(item.quantity) > 0 && config.glassEligibleProductIds.has(String(item.product_id || ''));
    });
    var glassAvailable = config.currentProductId && config.glassEligibleProductIds.has(config.currentProductId);
    var qualifyingSubtotal = config.qualificationBasis === 'original'
      ? paidCart.originalSubtotal
      : paidCart.subtotal;
    var remainingItems = Math.max(0, REQUIRED_PAID_QUANTITY - paidCart.quantity);
    var remainingSpend = Math.max(0, config.qualificationThreshold - qualifyingSubtotal);
    var itemRequirementMet = paidCart.quantity >= REQUIRED_PAID_QUANTITY;
    var spendRequirementMet = qualifyingSubtotal >= config.qualificationThreshold;
    var k3Unlocked = itemRequirementMet && spendRequirementMet;
    var thresholdText = formatMoney(config.threshold, config.currency, config.language);
    var message;

    if (!itemRequirementMet && spendRequirementMet) {
      message = interpolate(
        remainingItems === 1 ? copy.addOneForK3 : copy.addManyForK3,
        { count: remainingItems }
      );
    } else if (!itemRequirementMet) {
      message = interpolate(
        remainingItems === 1 ? copy.addOne : copy.addMany,
        { count: remainingItems }
      );
    } else if (!spendRequirementMet) {
      message = interpolate(
        config.qualificationBasis === 'original' && copy.spendMoreOriginal
          ? copy.spendMoreOriginal
          : copy.spendMore,
        { amount: formatMoney(remainingSpend, config.currency, config.language) }
      );
    } else {
      message = copy.k3Unlocked;
    }

    var itemProgress = Math.min(paidCart.quantity / REQUIRED_PAID_QUANTITY, 1) * 50;
    var spendProgress = Math.min(qualifyingSubtotal / config.qualificationThreshold, 1) * 50;
    var progress = Math.max(0, Math.min(100, Math.round(itemProgress + spendProgress)));

    setText(widget, '[data-gift-eyebrow]', copy.eyebrow);
    setText(widget, '[data-gift-message]', message);
    setText(widget, '[data-gift-item-step]', copy.itemStep);
    setText(widget, '[data-gift-k3-step]', interpolate(copy.k3Step, { threshold: thresholdText }));
    setText(widget, '[data-gift-limited]', copy.limited);

    var progressBar = widget.querySelector('[data-gift-progressbar]');
    var progressFill = widget.querySelector('[data-gift-progress-fill]');
    var itemStep = widget.querySelector('[data-gift-step-items]');
    var k3Step = widget.querySelector('[data-gift-step-k3]');
    var steps = widget.querySelector('[data-gift-steps]');
    var campaignLink = widget.querySelector('[data-gift-campaign-link]');
    var discountLink = widget.querySelector('[data-gift-discount-link]');
    var glassMessage = widget.querySelector('[data-gift-glass-message]');

    if (glassMessage) {
      if (glassUnlocked) {
        glassMessage.textContent = copy.glassUnlocked;
        glassMessage.hidden = false;
        glassMessage.classList.add('is-unlocked');
      } else if (glassAvailable) {
        glassMessage.textContent = copy.glassAvailable;
        glassMessage.hidden = false;
        glassMessage.classList.remove('is-unlocked');
      } else {
        glassMessage.textContent = '';
        glassMessage.hidden = true;
        glassMessage.classList.remove('is-unlocked');
      }
    }

    if (progressBar) {
      progressBar.setAttribute('aria-label', copy.progressLabel);
      progressBar.setAttribute('aria-valuenow', String(progress));
    }
    if (progressFill) progressFill.style.width = progress + '%';
    if (itemStep) itemStep.classList.toggle('is-complete', itemRequirementMet);
    if (k3Step) k3Step.classList.toggle('is-complete', k3Unlocked);

    if (steps) steps.hidden = Boolean(buttons.campaignVisible && buttons.campaignUrl);
    if (campaignLink) {
      if (buttons.campaignVisible && buttons.campaignButton && buttons.campaignUrl) {
        campaignLink.textContent = buttons.campaignButton;
        campaignLink.href = buttons.campaignUrl;
        campaignLink.hidden = false;
      } else {
        campaignLink.textContent = '';
        campaignLink.removeAttribute('href');
        campaignLink.hidden = true;
      }
    }
    if (discountLink) {
      discountLink.classList.remove('is-copied', 'is-copy-failed');
      discountLink.removeAttribute('aria-busy');
      if (buttons.discountAction === 'copy' && buttons.discountCode && buttons.discountButton) {
        discountLink.textContent = buttons.discountButton;
        discountLink.href = '#';
        discountLink.dataset.copyDiscountCode = buttons.discountCode;
        discountLink.dataset.copyDefaultText = buttons.discountButton;
        discountLink.dataset.copySuccessText = buttons.discountCopied;
        discountLink.dataset.copyFailedText = buttons.discountCopyFailed;
        discountLink.dataset.copyResetMs = String(buttons.copyResetMs);
        discountLink.setAttribute('role', 'button');
        discountLink.hidden = false;
      } else if (buttons.discountAction === 'link' && buttons.discountUrl && buttons.discountButton) {
        discountLink.textContent = buttons.discountButton;
        discountLink.href = buttons.discountUrl;
        delete discountLink.dataset.copyDiscountCode;
        delete discountLink.dataset.copyDefaultText;
        delete discountLink.dataset.copySuccessText;
        delete discountLink.dataset.copyFailedText;
        delete discountLink.dataset.copyResetMs;
        discountLink.removeAttribute('role');
        discountLink.hidden = false;
      } else {
        discountLink.textContent = '';
        discountLink.removeAttribute('href');
        delete discountLink.dataset.copyDiscountCode;
        delete discountLink.dataset.copyDefaultText;
        delete discountLink.dataset.copySuccessText;
        delete discountLink.dataset.copyFailedText;
        delete discountLink.dataset.copyResetMs;
        discountLink.removeAttribute('role');
        discountLink.hidden = true;
      }
    }

    widget.dataset.status = k3Unlocked ? 'k3' : (itemRequirementMet ? 'keychain' : 'pending');
    widget.dataset.glassStatus = glassUnlocked ? 'unlocked' : (glassAvailable ? 'available' : 'none');
    widget.style.removeProperty('display');
    widget.hidden = false;
  }

  function renderCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    lastCart = cart;
    document.querySelectorAll(SELECTOR).forEach(function (widget) {
      renderWidget(widget, cart);
    });
  }

  function getCartUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function getCartUpdateUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';
    return root.replace(/\/?$/, '/') + 'cart/update.js';
  }

  function applyDiscountCode(code) {
    var normalisedCode = String(code || '').trim();
    var sequence = ++discountRequestSequence;

    return window.fetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: normalisedCode })
    }).then(function (response) {
      if (!response.ok) throw new Error('Discount request failed with HTTP ' + response.status);
      return response.json();
    }).then(function (cart) {
      if (sequence === discountRequestSequence) renderCart(cart);

      document.dispatchEvent(new CustomEvent('aoocci:discount-applied', {
        detail: { cart: cart, code: normalisedCode }
      }));
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cart }
      }));
      document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        detail: { cart: cart }
      }));
      return cart;
    }).catch(function (error) {
      console.warn('[AOOCCI Gift Progress] Unable to apply discount code.', error);
      scheduleRefresh(0);
      return null;
    });
  }

  function refresh() {
    if (!document.querySelector(SELECTOR)) return Promise.resolve(null);

    var sequence = ++requestSequence;
    return window.fetch(getCartUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed with HTTP ' + response.status);
      return response.json();
    }).then(function (cart) {
      if (sequence === requestSequence) renderCart(cart);
      return cart;
    }).catch(function (error) {
      console.warn('[AOOCCI Gift Progress] Unable to refresh cart.', error);
      return null;
    });
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, typeof delay === 'number' ? delay : 180);
  }

  function cartFromEvent(event) {
    if (!event || !event.detail) return null;
    if (event.detail.cart && Array.isArray(event.detail.cart.items)) return event.detail.cart;
    if (Array.isArray(event.detail.items)) return event.detail;
    return null;
  }

  function installEventListeners() {
    [
      'shopify:cart:lines-update',
      'cart:updated',
      'cart:refresh',
      'theme:cart:updated',
      'ajaxProduct:added',
      'product:added'
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        var cart = cartFromEvent(event);
        if (cart) renderCart(cart);
        else scheduleRefresh(180);
      });
    });

    window.addEventListener('pageshow', function () { scheduleRefresh(0); });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleRefresh(0);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('form[action*="/cart"]')) scheduleRefresh(700);
    }, true);

    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-gift-discount-link][data-copy-discount-code]');
      if (!button) return;

      event.preventDefault();
      if (button.dataset.copyPending === 'true') return;

      var code = button.dataset.copyDiscountCode;
      var defaultText = button.dataset.copyDefaultText || button.textContent;
      var successText = button.dataset.copySuccessText || code;
      var failedText = button.dataset.copyFailedText || defaultText;
      var resetMs = Math.max(1000, Math.min(10000, parsePositiveInteger(button.dataset.copyResetMs) || 2200));

      button.dataset.copyPending = 'true';
      button.setAttribute('aria-busy', 'true');
      window.clearTimeout(button.__aoocciCopyResetTimer);

      copyTextToClipboard(code).then(function (copied) {
        button.textContent = copied ? successText : failedText;
        button.classList.toggle('is-copied', copied);
        button.classList.toggle('is-copy-failed', !copied);
        button.dataset.copyPending = 'false';
        button.setAttribute('aria-busy', 'false');

        if (copied) {
          document.dispatchEvent(new CustomEvent('aoocci:discount-code-copied', {
            detail: { code: code }
          }));
        }

        button.__aoocciCopyResetTimer = window.setTimeout(function () {
          if (!button.isConnected || button.dataset.copyDiscountCode !== code) return;
          button.textContent = defaultText;
          button.classList.remove('is-copied', 'is-copy-failed');
        }, resetMs);
      });
    });

    /*
      Kalles/T4S normally stores the code in #CartDiscountcode. Applying it
      through cart/update.js makes the discounted cart total available before
      checkout, so the gift threshold can be evaluated correctly.
    */
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-action="save-discountcode"]');
      if (!button) return;

      var scope = button.closest('.t4s-mini_cart-tool__content') || button.closest('form') || document;
      var input = scope.querySelector('#CartDiscountcode, [data-name="discount"]');
      if (input) applyDiscountCode(input.value);
    });

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('#CartDiscountcode, [data-name="discount"]')) return;

      /* The drawer has its own Save button; the cart page does not. */
      var drawerTool = input.closest('.t4s-mini_cart-tool__content');
      if (!drawerTool) applyDiscountCode(input.value);
    });

    document.addEventListener('keydown', function (event) {
      var input = event.target;
      if (event.key !== 'Enter' || !input.matches || !input.matches('#CartDiscountcode, [data-name="discount"]')) return;

      event.preventDefault();
      applyDiscountCode(input.value);
    });
  }

  function isCartMutationRequest(input, init) {
    var url = '';
    var method = String((init && init.method) || '').toUpperCase();

    if (typeof input === 'string') url = input;
    else if (input && input.url) {
      url = input.url;
      if (!method && input.method) method = String(input.method).toUpperCase();
    }

    if (!method) method = 'GET';
    return method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/i.test(url);
  }

  function installFetchHook() {
    if (!window.fetch || window.fetch.__aoocciGiftProgressWrapped) return;

    var nativeFetch = window.fetch;
    var wrappedFetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var shouldRefresh = isCartMutationRequest(args[0], args[1]);
      var result = nativeFetch.apply(this, args);

      if (shouldRefresh) {
        result.then(
          function () { scheduleRefresh(120); },
          function () { scheduleRefresh(250); }
        );
      }
      return result;
    };

    wrappedFetch.__aoocciGiftProgressWrapped = true;
    window.fetch = wrappedFetch;
  }

  function installXhrHook() {
    if (!window.XMLHttpRequest || XMLHttpRequest.prototype.__aoocciGiftProgressWrapped) return;

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__aoocciGiftProgressIsCartMutation =
        String(method || 'GET').toUpperCase() !== 'GET' &&
        /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/i.test(String(url || ''));
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__aoocciGiftProgressIsCartMutation) {
        this.addEventListener('loadend', function () { scheduleRefresh(120); }, { once: true });
      }
      return nativeSend.apply(this, arguments);
    };

    XMLHttpRequest.prototype.__aoocciGiftProgressWrapped = true;
  }

  function installWidgetObserver() {
    if (!window.MutationObserver || !document.documentElement) return;

    var observer = new MutationObserver(function (mutations) {
      var foundWidget = false;
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (foundWidget || node.nodeType !== 1) return;
          if ((node.matches && node.matches(SELECTOR)) || (node.querySelector && node.querySelector(SELECTOR))) {
            foundWidget = true;
          }
        });
      });

      if (foundWidget) {
        if (lastCart) renderCart(lastCart);
        else scheduleRefresh(0);
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function installStyles() {
    if (document.getElementById('aoocci-gift-progress-styles')) return;

    var style = document.createElement('style');
    style.id = 'aoocci-gift-progress-styles';
    style.textContent = [
      '.aoocci-gift-progress__discount-link.is-copied{border-color:#62dc91;background:rgba(44,170,96,.18);color:#d9ffe7!important}',
      '.aoocci-gift-progress__discount-link.is-copy-failed{border-color:#ff8c8c;background:rgba(195,45,45,.18);color:#ffe1e1!important}',
      '.aoocci-gift-progress{--agp-accent:#f4b942;--agp-accent-2:#fff0b5;--agp-bg:#45121e;--agp-text:#fff;--agp-muted:#f0d9c4;--agp-track:rgba(255,255,255,.16);position:relative;isolation:isolate;overflow:hidden;box-sizing:border-box;width:100%;margin:14px 0;padding:16px;border:1px solid rgba(255,211,106,.3);border-radius:12px;background:radial-gradient(circle at 91% 15%,rgba(244,185,66,.24) 0,rgba(244,185,66,.08) 22%,transparent 43%),radial-gradient(circle at 2% 100%,rgba(190,65,49,.22) 0,transparent 44%),linear-gradient(135deg,#38111b 0%,#641d29 58%,#8a2c2a 100%);color:var(--agp-text);box-shadow:0 10px 28px rgba(70,18,28,.2)}',
      '.aoocci-gift-progress[hidden]{display:none!important}',
      '.aoocci-gift-progress::before{content:"";position:absolute;z-index:-1;top:10px;left:13px;width:55px;height:23px;background:url("data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%20110%2046%27%3E%3Cg%20fill%3D%27%23ffe6a3%27%3E%3Cpath%20d%3D%27M22%204l4%2012%2012%204-12%204-4%2012-4-12-12-4%2012-4zM75%206l3%209%209%203-9%203-3%209-3-9-9-3%209-3zM98%2027l2%206%206%202-6%202-2%206-2-6-6-2%206-2z%27%2F%3E%3Ccircle%20cx%3D%2748%27%20cy%3D%2734%27%20r%3D%272%27%2F%3E%3Ccircle%20cx%3D%2752%27%20cy%3D%278%27%20r%3D%272%27%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E") center/contain no-repeat;opacity:.25;transform:rotate(-7deg);pointer-events:none}',
      '.aoocci-gift-progress::after{content:"";position:absolute;z-index:-1;top:5px;right:7px;width:76px;height:67px;background:url("data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%20120%20106%27%3E%3Cpath%20fill%3D%27%23ffd36a%27%20d%3D%27M61%208c2%2015%2017%2020%2017%2034a18%2018%200%200%201-36%200C42%2028%2056%2020%2061%208z%27%2F%3E%3Cpath%20fill%3D%27%23fff2be%27%20d%3D%27M60%2030c0%208%208%2012%208%2019a8%208%200%200%201-16%200c0-7%206-12%208-19z%27%2F%3E%3Cpath%20fill%3D%27%23e99b35%27%20stroke%3D%27%23ffe6a3%27%20stroke-width%3D%273%27%20d%3D%27M13%2062h94c-8%2024-24%2034-47%2034S21%2086%2013%2062z%27%2F%3E%3Cellipse%20cx%3D%2760%27%20cy%3D%2762%27%20rx%3D%2747%27%20ry%3D%278%27%20fill%3D%27%23902a30%27%20stroke%3D%27%23ffe6a3%27%20stroke-width%3D%273%27%2F%3E%3Cpath%20d%3D%27M60%2058v7M32%2078q28%2017%2056%200%27%20fill%3D%27none%27%20stroke%3D%27%23ffe6a3%27%20stroke-width%3D%273%27%20stroke-linecap%3D%27round%27%2F%3E%3C%2Fsvg%3E") center/contain no-repeat;opacity:.25;transform:rotate(4deg);pointer-events:none}',
      '.aoocci-gift-progress *{position:relative;z-index:1;box-sizing:border-box}',
      '.aoocci-gift-progress__head{display:flex;align-items:flex-start;gap:10px}',
      '.aoocci-gift-progress__icon{flex:0 0 28px;width:28px;height:28px;color:#ffd36a}',
      '.aoocci-gift-progress__copy{min-width:0;flex:1}',
      '.aoocci-gift-progress__eyebrow{margin:0 0 4px;color:#ffe2a0;font-size:11px;font-weight:800;line-height:1.2;letter-spacing:.09em}',
      '.aoocci-gift-progress__eyebrow{display:flex;align-items:center;gap:7px}',
      '.aoocci-gift-progress__eyebrow::before{content:"";display:block;flex:0 0 22px;width:22px;height:22px;background:url("data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%20120%20106%27%3E%3Cpath%20fill%3D%27%23ffd36a%27%20d%3D%27M61%208c2%2015%2017%2020%2017%2034a18%2018%200%200%201-36%200C42%2028%2056%2020%2061%208z%27%2F%3E%3Cpath%20fill%3D%27%23fff2be%27%20d%3D%27M60%2030c0%208%208%2012%208%2019a8%208%200%200%201-16%200c0-7%206-12%208-19z%27%2F%3E%3Cpath%20fill%3D%27%23e99b35%27%20stroke%3D%27%23ffe6a3%27%20stroke-width%3D%273%27%20d%3D%27M13%2062h94c-8%2024-24%2034-47%2034S21%2086%2013%2062z%27%2F%3E%3Cellipse%20cx%3D%2760%27%20cy%3D%2762%27%20rx%3D%2747%27%20ry%3D%278%27%20fill%3D%27%23902a30%27%20stroke%3D%27%23ffe6a3%27%20stroke-width%3D%273%27%2F%3E%3Cpath%20d%3D%27M60%2058v7M32%2078q28%2017%2056%200%27%20fill%3D%27none%27%20stroke%3D%27%23ffe6a3%27%20stroke-width%3D%273%27%20stroke-linecap%3D%27round%27%2F%3E%3C%2Fsvg%3E") center/contain no-repeat}',
      '.aoocci-gift-progress__message{margin:0;color:var(--agp-text);font-size:14px;font-weight:700;line-height:1.42}',
      '.aoocci-gift-progress__glass{position:relative;margin:9px 0 0;padding:8px 10px 8px 30px;border:1px solid rgba(255,211,106,.38);border-radius:8px;background:rgba(244,185,66,.1);color:#ffe3c2;font-size:11px;font-weight:700;line-height:1.4}',
      '.aoocci-gift-progress__glass[hidden]{display:none!important}',
      '.aoocci-gift-progress__glass::before{content:"✓";position:absolute;top:8px;left:10px;width:14px;height:14px;border-radius:50%;background:#f4b942;color:#45151b;font-size:10px;font-weight:900;line-height:14px;text-align:center}',
      '.aoocci-gift-progress__glass.is-unlocked{border-color:rgba(94,214,140,.46);background:rgba(44,170,96,.13);color:#d9ffe7}',
      '.aoocci-gift-progress__glass.is-unlocked::before{background:#5ed68c}',
      '.aoocci-gift-progress__bar{position:relative;height:7px;margin:14px 0 9px;overflow:hidden;border:1px solid rgba(255,255,255,.08);border-radius:999px;background:var(--agp-track)}',
      '.aoocci-gift-progress__fill{display:block;width:0;height:100%;border-radius:inherit;background:linear-gradient(90deg,#f4b942 0%,#f9d477 52%,var(--agp-accent-2) 100%);box-shadow:0 0 10px rgba(244,185,66,.42);transition:width .3s ease}',
      '.aoocci-gift-progress__steps{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:0;padding:0;list-style:none}',
      '.aoocci-gift-progress__steps[hidden]{display:none!important}',
      '.aoocci-gift-progress__step{position:relative;margin:0;padding-left:16px;color:var(--agp-muted);font-size:11px;line-height:1.35}',
      '.aoocci-gift-progress__step::before{content:"";position:absolute;top:.27em;left:0;width:9px;height:9px;border:2px solid #ba8d74;border-radius:50%;background:var(--agp-bg)}',
      '.aoocci-gift-progress__step.is-complete{color:#fff;font-weight:700}',
      '.aoocci-gift-progress__step.is-complete::before{border-color:#f4b942;background:#f4b942;box-shadow:0 0 0 3px rgba(244,185,66,.15)}',
      '.aoocci-gift-progress__campaign-link{display:flex;align-items:center;justify-content:center;width:100%;min-height:38px;margin:10px 0 0;padding:9px 14px;border:1px solid #f9d477;border-radius:8px;background:linear-gradient(135deg,#f4b942 0%,#f9d477 100%);color:#45151b!important;font-size:12px;font-weight:800;line-height:1.25;text-align:center;text-decoration:none!important;box-shadow:0 5px 14px rgba(244,185,66,.2);transition:background .2s ease,box-shadow .2s ease,transform .2s ease}',
      '.aoocci-gift-progress__campaign-link[hidden]{display:none!important}',
      '.aoocci-gift-progress__campaign-link:hover,.aoocci-gift-progress__campaign-link:visited,.aoocci-gift-progress__campaign-link:active{color:#45151b!important;text-decoration:none!important}',
      '.aoocci-gift-progress__campaign-link:hover{background:linear-gradient(135deg,#ffd36a 0%,#ffe2a0 100%);box-shadow:0 7px 18px rgba(244,185,66,.28);transform:translateY(-1px)}',
      '.aoocci-gift-progress__campaign-link:focus,.aoocci-gift-progress__campaign-link:focus-visible{color:#45151b!important;text-decoration:none!important;outline:2px solid #fff;outline-offset:2px}',
      '.aoocci-gift-progress__discount-link{display:flex;align-items:center;justify-content:center;width:100%;min-height:38px;margin:8px 0 0;padding:9px 14px;border:1px solid rgba(255,226,160,.72);border-radius:8px;background:rgba(255,255,255,.07);color:#ffe2a0!important;font-size:12px;font-weight:800;line-height:1.25;text-align:center;text-decoration:none!important;box-shadow:inset 0 0 0 1px rgba(255,255,255,.03);transition:background .2s ease,border-color .2s ease,color .2s ease,transform .2s ease}',
      '.aoocci-gift-progress__discount-link[hidden]{display:none!important}',
      '.aoocci-gift-progress__discount-link:hover,.aoocci-gift-progress__discount-link:visited,.aoocci-gift-progress__discount-link:active{color:#ffe2a0!important;text-decoration:none!important}',
      '.aoocci-gift-progress__discount-link:hover{border-color:#ffe2a0;background:rgba(244,185,66,.14);color:#fff1d6!important;transform:translateY(-1px)}',
      '.aoocci-gift-progress__discount-link:focus,.aoocci-gift-progress__discount-link:focus-visible{color:#ffe2a0!important;text-decoration:none!important;outline:2px solid #fff;outline-offset:2px}',
      '.aoocci-gift-progress__limited{margin:11px 0 0;color:#e1c2ac;font-size:10px;line-height:1.45}',
      '.aoocci-gift-progress__limited:empty{display:none}',
      '.aoocci-gift-progress[data-status="k3"]{border-color:rgba(255,211,106,.58);box-shadow:0 10px 30px rgba(111,35,40,.24)}',
      '@media (max-width:479px){.aoocci-gift-progress{padding:14px;border-radius:10px;background:radial-gradient(circle at 94% 10%,rgba(244,185,66,.2) 0,transparent 36%),radial-gradient(circle at 2% 100%,rgba(190,65,49,.2) 0,transparent 42%),linear-gradient(135deg,#38111b 0%,#641d29 62%,#8a2c2a 100%)}.aoocci-gift-progress::before{top:8px;left:9px;width:44px;height:18px;opacity:.13}.aoocci-gift-progress::after{top:7px;right:5px;width:57px;height:50px;opacity:.17}.aoocci-gift-progress__steps{gap:8px}.aoocci-gift-progress__message{font-size:13px}}',
      '@media (prefers-reduced-motion:reduce){.aoocci-gift-progress__fill{transition:none}}'
    ].join('');
    document.head.appendChild(style);
  }

  function initialise() {
    installStyles();
    installEventListeners();
    installFetchHook();
    installXhrHook();
    installWidgetObserver();
    refresh();
  }

  window[GLOBAL_KEY] = {
    initialized: true,
    refresh: refresh,
    renderCart: renderCart
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
}());
